export default "__VITE_ASSET__c9f8a667__"